import { Component, Input, OnInit, Output, EventEmitter, HostBinding } from '@angular/core';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ViewService } from '../../view.service';

@Component({
    selector: 'unit-map',
    templateUrl: './unit-map.component.html',
    styleUrls: ['./unit-map.component.scss']
})
export class UnitMapComponent extends AdUtils implements OnInit {

    @Input() showType : boolean = false;
    @Input() _data : any = {};
    @Input() legend : boolean = true;
    @Input()
    set block(val: any) {
        this._block = val? val : null;
        this.generateTable(this._block);
    }
    get block(){
        return this._block;
    }

    @Input() unitClass : any = '';
    @Input()
    set unitFocus(val: any) {
        this._unitFocus = val? val : null;

    }
    get unitFocus(){
        return this._unitFocus;
    }
    @Output() unitSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() unitFocused: EventEmitter<boolean> = new EventEmitter<boolean>();
    @HostBinding('className') className = '';

    _unitFocus:any = null;
    _block:any = false;

    eventCallback(e){}
    setDefault(){}

    constructor( 
        srs : AdSearchService,
        gs : GeneralService,
        vs : ViewService
    ){
        super(srs, gs, vs);      

    }

    ngOnInit(){
        this.data = this._data;
        
        this.className = this.unitClass;
        
        if(this._block)
            this.generateTable(this._block);
    }

    setUnitFocus(unit = null){
        this._unitFocus = unit;
        this.unitFocused.emit(unit);
    }
  
    async openUnitDetail(ev: any, data) {  
        this.unitSelected.emit(data);
    }

    compareWith = (o1, o2) => {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

    selBlock(ev) {
        this.tableBlockSelected = ev.detail.value;
    }

}